import { Box } from '@mui/material';
import ContactForm from './ContactForm';

export default function ContactSection() {
  return (
    <Box sx={{ width: '100%', backgroundColor: '#0A6274' }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '1440px',
          mx: 'auto',
          height: { xs: 'auto', md: 'auto' },
          px: { xs: 2, sm: 3, md: 10 },
          py: { xs: 4, sm: 6, md: 10 },
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          position: 'relative',
        }}
      >
        <ContactForm />

        {/* Imagen decorativa */}
        <Box
          sx={{
            display: { xs: 'none', md: 'block' },
            position: 'absolute',
            top: '145px',
            right: 0,
            zIndex: 0,
          }}
        >
          <img
            src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193322/ebm/seccionContactanosFormulario_nyjc54.png"
            alt="Figura decorativa"
            style={{
              height: 'auto',
              maxHeight: '578px',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}